import { render, staticRenderFns } from "./store-widgets.vue?vue&type=template&id=174f4f4d"
import script from "./store-widgets.vue?vue&type=script&lang=js"
export * from "./store-widgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports